export const gtagEvent = ({ action, category, label, value = 0 }) => {
  window.gtag &&
    window.gtag('event', action, {
      event_category: category,
      event_label: label,
      value: value
    })
}
